import axios from 'axios';
import api from '@/utils/api'
import store from '@/store'


axios.defaults.timeout = 2000000;
axios.defaults.baseURL = '';


//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = config.data;
    config.headers = {
      'Content-Type': 'application/json'
    };
    config.onUploadProgress = function (progressEvent) {
      let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
      store.dispatch('changeComplete', complete)
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.sta == -500) {
      if(!wemeet.app.isTMWebview()) localStorage.removeItem("token");
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    if(params && params.loadingMsg !== 'no') {
      store.commit("changeLoading", { status: true });
    }
    if(params.loadingMsg) delete params.loadingMsg;
    axios.get(api.questionBaseUrl + url, {
      params: params
    })
      .then(response => {
        if(store.state.showLoading) {
          store.commit("changeLoading", { status: false });
        }
        handleTimer(url, response.data.data)
        resolve(response.data);
      })
      .catch(err => {
        if(store.state.showLoading) {
          store.commit("changeLoading", { status: false });
        }
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function post(url, data = {}, config) {
  return new Promise((resolve, reject) => {
    if(data && data.loadingMsg !== 'no') {
      store.commit("changeLoading", { status: true });
    }
    if(data.loadingMsg) delete data.loadingMsg;
    axios.post(api.questionBaseUrl + url, data, config)
      .then(response => {
        store.commit("changeLoading", { status: false });
        resolve(response.data);
      }, err => {
        store.commit("changeLoading", { status: false });
        reject(err)
      })
  })
}

const handleTimer = (url, data) => {
  let urlArr = ['/xcx/ques/v1/detail/home', '/xcx/ques/v1/submit/staging', '/xcx/ques/v3/detail']
  if(urlArr.indexOf(url) > -1 && data && data.now) {
    let differTimer = Number(data.now * 1000) - new Date().getTime();
    localStorage.setItem('differTimer', differTimer)
  }
}


export default {
  get,
  post
}



// WEBPACK FOOTER //
// ./src/utils/questionOnly.js